import React from 'react';
import Link from 'next/link';

const UserIconBlack = ({
  className,
}: {
  className?: string;
}): React.ReactElement => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 36 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M18 0C15.7019 0 13.4262 0.452651 11.303 1.33211C9.17984 2.21157 7.25066 3.50061 5.62563 5.12563C2.34374 8.40752 0.5 12.8587 0.5 17.5C0.5 22.1413 2.34374 26.5925 5.62563 29.8744C7.25066 31.4994 9.17984 32.7884 11.303 33.6679C13.4262 34.5474 15.7019 35 18 35C22.6413 35 27.0925 33.1563 30.3744 29.8744C33.6563 26.5925 35.5 22.1413 35.5 17.5C35.5 15.2019 35.0474 12.9262 34.1679 10.803C33.2884 8.67984 31.9994 6.75066 30.3744 5.12563C28.7493 3.50061 26.8202 2.21157 24.697 1.33211C22.5738 0.452651 20.2981 0 18 0ZM9.3725 28.49C10.125 26.915 14.71 25.375 18 25.375C21.29 25.375 25.875 26.915 26.6275 28.49C24.1759 30.4422 21.1339 31.5035 18 31.5C14.745 31.5 11.7525 30.38 9.3725 28.49ZM29.13 25.9525C26.6275 22.9075 20.555 21.875 18 21.875C15.445 21.875 9.3725 22.9075 6.87 25.9525C5.00856 23.528 3.99968 20.5567 4 17.5C4 9.7825 10.2825 3.5 18 3.5C25.7175 3.5 32 9.7825 32 17.5C32 20.685 30.915 23.625 29.13 25.9525ZM18 7C14.605 7 11.875 9.73 11.875 13.125C11.875 16.52 14.605 19.25 18 19.25C21.395 19.25 24.125 16.52 24.125 13.125C24.125 9.73 21.395 7 18 7ZM18 15.75C17.3038 15.75 16.6361 15.4734 16.1438 14.9812C15.6516 14.4889 15.375 13.8212 15.375 13.125C15.375 12.4288 15.6516 11.7611 16.1438 11.2688C16.6361 10.7766 17.3038 10.5 18 10.5C18.6962 10.5 19.3639 10.7766 19.8562 11.2688C20.3484 11.7611 20.625 12.4288 20.625 13.125C20.625 13.8212 20.3484 14.4889 19.8562 14.9812C19.3639 15.4734 18.6962 15.75 18 15.75Z"
      fill="currentColor"
    />
  </svg>
);

const UserIconWhite = ({
  className,
}: {
  className?: string;
}): React.ReactElement => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16.5 0C14.3332 0 12.1876 0.426785 10.1857 1.25599C8.18385 2.08519 6.36491 3.30057 4.83274 4.83274C1.73839 7.92709 0 12.1239 0 16.5C0 20.8761 1.73839 25.0729 4.83274 28.1673C6.36491 29.6994 8.18385 30.9148 10.1857 31.744C12.1876 32.5732 14.3332 33 16.5 33C20.8761 33 25.0729 31.2616 28.1673 28.1673C31.2616 25.0729 33 20.8761 33 16.5C33 14.3332 32.5732 12.1876 31.744 10.1857C30.9148 8.18385 29.6994 6.36491 28.1673 4.83274C26.6351 3.30057 24.8162 2.08519 22.8143 1.25599C20.8124 0.426785 18.6668 0 16.5 0ZM8.3655 26.862C9.075 25.377 13.398 23.925 16.5 23.925C19.602 23.925 23.925 25.377 24.6345 26.862C22.323 28.7026 19.4548 29.7033 16.5 29.7C13.431 29.7 10.6095 28.644 8.3655 26.862ZM26.994 24.4695C24.6345 21.5985 18.909 20.625 16.5 20.625C14.091 20.625 8.3655 21.5985 6.006 24.4695C4.25093 22.1835 3.2997 19.382 3.3 16.5C3.3 9.2235 9.2235 3.3 16.5 3.3C23.7765 3.3 29.7 9.2235 29.7 16.5C29.7 19.503 28.677 22.275 26.994 24.4695ZM16.5 6.6C13.299 6.6 10.725 9.174 10.725 12.375C10.725 15.576 13.299 18.15 16.5 18.15C19.701 18.15 22.275 15.576 22.275 12.375C22.275 9.174 19.701 6.6 16.5 6.6ZM16.5 14.85C15.8436 14.85 15.2141 14.5892 14.7499 14.1251C14.2858 13.6609 14.025 13.0314 14.025 12.375C14.025 11.7186 14.2858 11.0891 14.7499 10.6249C15.2141 10.1608 15.8436 9.9 16.5 9.9C17.1564 9.9 17.7859 10.1608 18.2501 10.6249C18.7142 11.0891 18.975 11.7186 18.975 12.375C18.975 13.0314 18.7142 13.6609 18.2501 14.1251C17.7859 14.5892 17.1564 14.85 16.5 14.85Z"
      fill="currentColor"
    />
  </svg>
);

export default function UserSignInIcon({
  isBackgroundWhite,
}: {
  isBackgroundWhite: boolean;
}): React.ReactElement {
  return (
    <Link href="/sign-in" className="group" aria-label="Sign in">
      <div className="relative transition-all duration-300 ease-in-out group-hover:scale-110">
        <div className="absolute inset-0 scale-150 transform rounded-full bg-linear-to-t from-[#D64718] to-[#E98C6C] opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-20"></div>
        {isBackgroundWhite ? (
          <UserIconBlack className="relative z-10 text-black transition-colors duration-300 ease-in-out group-hover:text-[#8875D5]" />
        ) : (
          <UserIconWhite className="relative z-10 text-white transition-colors duration-300 ease-in-out group-hover:text-[#C3B5FF]" />
        )}
      </div>
    </Link>
  );
}
